import { Action } from '@occc-app/rootRedux';

import types, { LOCATION_IN_STATE, REQUIRES_ACTIVATION, State } from './types';

import { default as offerTypes } from '../../../redux/types';

export const initialState: State = {
  requiresActivation: {
    type: REQUIRES_ACTIVATION,
    active: false,
    mustFulfillWithinDays: 7,
    mustFulfillWithinDaysActive: false,
    error: null,
    errorMessages: [],
    id: '',
    dirty: false,
    submitting: false,
  },
  locationInState: {
    type: LOCATION_IN_STATE,
    active: false,
    states: [],
    error: null,
    errorMessages: [],
    id: '',
    dirty: false,
    submitting: false,
  },
  error: null,
  errorMessages: [],
  requesting: true,
};

export function reducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case types.CONSTRAINT_COMPONENT_ERR:
      const { constraintType: constraintTypeERR, error, errorMessages } = action;
      return {
        ...state,
        [constraintTypeERR]: {
          ...state[constraintTypeERR],
          error,
          errorMessages,
        },
      };
    case types.CONSTRAINT_COMPONENT_OK:
      const { constraintType: constraintTypeOK, id } = action;
      return {
        ...state,
        [constraintTypeOK]: {
          ...state[constraintTypeOK],
          id,
          error: null,
          errorMessages: [],
          dirty: false,
        },
      };
    case types.CONSTRAINT_COMPONENTS_ERR:
      const { error: constraintComponentsError, errorMessages: constraintComponentsErrorMessages } =
        action;
      return {
        ...state,
        error: constraintComponentsError,
        errorMessages: constraintComponentsErrorMessages,
      };
    case types.CONSTRAINT_COMPONENTS_OK:
      return {
        ...state,
        error: null,
        errorMessages: [],
      };
    case types.CONSTRAINT_CONFIGURATION_UPDATE:
      const { constraintConfigurationKey } = action;
      return {
        ...state,
        [constraintConfigurationKey]: {
          ...state[constraintConfigurationKey],
          [action.key]: action.value,
          dirty: true,
        },
      };
    case types.CONSTRAINT_TOGGLE_UPDATE:
      const { constraintConfigurationKey: toggledConfiguration } = action;
      return {
        ...state,
        [toggledConfiguration]: {
          ...state[toggledConfiguration],
          dirty: true,
          active: !state[toggledConfiguration].active,
        },
      };
    case types.REQUEST_CONSTRAINT:
      return {
        ...state,
        [action.constraintType]: {
          ...state[action.constraintType],
          id: action.id,
          error: null,
          errorMessages: [],
          dirty: true,
        },
      };
    case types.REQUEST_CONSTRAINT_OK:
      const selectedConstraintType = action.selectedConstraint.type;
      return {
        ...state,
        [selectedConstraintType]: {
          ...state[selectedConstraintType],
          error: null,
          errorMessages: [],
          dirty: false,
          ...action.selectedConstraint,
        },
      };
    case types.REQUEST_CONSTRAINTS_OK:
      return {
        ...state,
        requesting: false,
      };
    case types.RESET_INITIAL_CONSTRAINTS_STATE:
      return {
        ...state,
        ...action.constraints,
      };
    case offerTypes.CLEAR_OFFER_COMPONENT_STATE:
      return initialState;
  }
  return state;
}
